import React from "react";
import Footer from "../../common/Footer/Footer";
import AdminPayment from "../../components/AdminPayment/AdminPayment";
import UserPage from "../../common/UserPage/UserPage";


const AdminPaymentPage = () => {
  return (
    <div> 
    <UserPage />    
      <AdminPayment />
      <Footer />
    </div>
  );
};

export default AdminPaymentPage;